export default class {
    constructor (lodash) {
        this.lodash = lodash;
    }

    /**
     * Create a multiselect compatible tree with provided tree as a result param
     * @param result
     * @param level
     * @param excludeSite
     * @returns {[]}
     */
    mapSelectItems (result, level, excludeSite = null) {
        if (level === undefined) {
            level = 0;
        }
        const pad = '-';
        let selectItems = [];
        this.lodash.forEach(result, item => {
            if (!excludeSite || excludeSite.id !== item.id) {
                selectItems.push({
                    id: item.id,
                    parentId: item.parentId,
                    label: `${this.lodash.repeat(pad, level)} ${item.name}`
                });
            }

            if (item.childSites && item.childSites.length) {
                selectItems = selectItems.concat(this.mapSelectItems(item.childSites, level + 1, excludeSite));
            }
        });
        return selectItems;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/site/parent/index.js